module.exports = __webpack_public_path__ + "static/img/frown2.d6d05ee.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/frown2.png
// module id = K8oC
// module chunks = 1